import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from "react-router-dom";

import { Headerlp } from './header';
import { Pictext } from './pic-text';

import { Join } from './join';
import { Footer } from './footer';
import { Video2 } from './video2';
import { NavBar } from './nav';
import { TheirStories } from "./theirstories";
import styles from './lb.module.css'
import { useCookies } from '../hooks/useCookies';
import { useProfile } from "../components/userflow/components/context/ProfileContext";
import { handleUserNavigation } from "../utils/handleUserRedirect"
import Loader from './Utility/Loader';


export const LP = () => {
  const navigate = useNavigate();
  const [mobile, setMobile] = useState(false);
  const { getCookie } = useCookies();
  const [loading, setLoading] = useState(false);

  const token = getCookie('token')
  const userId = getCookie('userId')
  const { fetchProfile } = useProfile();

  const handleRouting = useCallback(async () => {
    const success = await fetchProfile();
    const result = success.data;

    if (!success.ok) return;
    if (result) {
      if (!result?.Email || result?.Email === "") {
        navigate("/emailverify");
      } else if (result?.Email) {
        await handleUserNavigation(result, navigate, setLoading, "");
      }
    } else {
      setLoading(false);
    }

  }, [fetchProfile, navigate, setLoading]);


  useEffect(() => {
    // Redirect to another URL
    if (token && userId) {
      handleRouting()
    }
    else {
      navigate("/");
    }
  }, [token, userId, handleRouting, navigate]);

  useEffect(() => {
    if (window.innerWidth <= 768) {
      setMobile(true);

    }
    window.addEventListener("resize", () => {
      if (window.innerWidth <= 768) {
        setMobile(true);
      } else {
        setMobile(false);
      }
    });
  }, [])
  if (loading) {
    return <Loader />;
  }
  return (

    <div className={styles.mainbox}>
      {
        !mobile && <NavBar />
      }

      <Headerlp />
      <Pictext />
      <TheirStories />
      <Video2 />
      <Join />
      <Footer />
    </div>
  );
}

